import React from 'react';
import type { AuthUser } from '../../types';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import AppLayout from './AppLayout';
import { isAdmin as checkAdmin } from '../../utils/auth';
import { useChurchConfig } from '../../hooks';
import { navLayoutOf } from '../../utils/churchSettings';
import { SETTINGS_ROUTE } from '../../routes';
import ApprovalNotice from '../../features/approvals/ApprovalNotice';

// Chrome that stays put while routes change underneath it.
export interface AppShellProps {
  user: AuthUser | null;
  onLogout: () => void;
}

const AppShell = ({ user, onLogout }: AppShellProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const config = useChurchConfig();

  return (
    <AppLayout
      user={user}
      isAdmin={checkAdmin(user)}
      layout={navLayoutOf(config)}
      atHome={location.pathname === '/'}
      onHome={() => navigate('/')}
      onOpenSettings={() => navigate(`/${SETTINGS_ROUTE}`)}
      onLogout={onLogout}
    >
      <ApprovalNotice />
      <Outlet />
    </AppLayout>
  );
};

export default AppShell;
